import {useContext, useEffect, useState} from "react";
import api from "services/api";
import AdminContempladoModal from './modal';
import './style.css';
import config from 'config';
import AdminSORTEIO from "./sorteio";
import {formatDate} from "components/formatos";
import {CidadeContext} from "services/cidade";
import PAGINACAO from "components/paginacao";

function AdminContemplado() {
    const [lcontemplado, setLContemplado] = useState([]);

    // Modal
    const [operacao, setOperacao] = useState('')
    const [dados, setDados] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenSorteio, setIsOpenSorteio] = useState(false);

    const { cod_cidade } = useContext(CidadeContext)

    function closeAdminContempladoModal() {
        setIsOpen(false);
    }
    function closeSorteio() {
        setIsOpenSorteio(false);
    }

    useEffect(() => {
        api.get(`${config.ADM_CONTEMPLADOS}?cod_cidade=${cod_cidade}`)
            .then(response => {
                setLContemplado(response.data);
            });
    }, [isOpen, isOpenSorteio, cod_cidade])

    function novaContemplado() {
        setDados({
            'id_sorteado': 0,
        });
        setIsOpen(true);
    }
    function novoSorteio() {
        setIsOpenSorteio(true);
    }

    function editarContemplado(linha) {
        api.get(`${config.ADM_CONTEMPLADOS}/${linha.id_sorteado}`)
            .then(response => {
                setOperacao('UPDATE')
                setDados(response.data[0]);
                setIsOpen(true);
            }).catch(err => {
                console.log(err)
                //document.location = `/empresaamiga/erro?m=No momento não conseguimos alcançar o servidor`
            })
    }


    return (
        <div>
            <AdminContempladoModal 
                isOpen={isOpen}
                onRequestClose={closeAdminContempladoModal}
                operacao={operacao}
                dados={dados}
            />
            <AdminSORTEIO 
                isOpen={isOpenSorteio}
                onRequestClose={closeSorteio}
                operacao={'SORTEIO'}
            />
            
            <div className="admin-header-section mb-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <h2 className="section-title mb-0">Gestão de Contemplados</h2>
                    <div className="d-flex gap-2">
                        <button 
                            className="btn btn-success d-flex align-items-center gap-2 px-4 py-2 shadow-sm" 
                            onClick={() => novoSorteio()}
                            style={{ borderRadius: '12px' }}
                        >
                            <i className="fas fa-trophy"></i>
                            <span>Novo Sorteio</span>
                        </button>
                        <button 
                            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 shadow-sm" 
                            onClick={() => novaContemplado()}
                            style={{ borderRadius: '12px' }}
                        >
                            <i className="fas fa-plus"></i>
                            <span>Lançar Ganhador</span>
                        </button>
                    </div>
                </div>
            </div>

            <PAGINACAO
                data={lcontemplado}
                itemsPerPage={12}
                renderItems={(currentItems) => (
                    <div className="row g-4">
                        {currentItems && currentItems.map((e, index) => (
                            <div className="col-12 col-md-6 col-lg-4 col-xl-3" key={`cntp-${index}`}>
                                <div className="contemplado-admin-card h-100 bg-card-admin rounded-4 overflow-hidden position-relative transition-all" onClick={() => editarContemplado(e)}>
                                    <div className="p-3 border-bottom d-flex align-items-center justify-content-between bg-light-subtle">
                                        <span className="text-muted small fw-bold">
                                            <i className="far fa-calendar-alt me-1"></i>
                                            {formatDate(e.data_sorteio)}
                                        </span>
                                        <div className="contemplado-medal">
                                            <i className="fas fa-medal text-warning"></i>
                                        </div>
                                    </div>
                                    
                                    <div className="p-4">
                                        <div className="text-muted small mb-1">Campanha</div>
                                        <h5 className="text-primary fw-bold mb-3 text-truncate" title={e.den_campanha}>
                                            {e.den_campanha}
                                        </h5>
                                        
                                        <div className="d-flex align-items-center gap-3 p-3 bg-light rounded-3">
                                            <div className="contemplado-avatar-mini bg-white rounded-circle d-flex align-items-center justify-content-center shadow-sm" style={{ width: '45px', height: '45px' }}>
                                                <i className="fas fa-user text-muted"></i>
                                            </div>
                                            <div className="overflow-hidden">
                                                <div className="text-muted small" style={{fontSize: '0.7rem'}}>Ganhador</div>
                                                <div className="fw-bold text-dark text-truncate" title={e.nome_sorteado}>
                                                    {e.nome_sorteado}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="p-3 border-top bg-light-subtle d-flex justify-content-center">
                                        <button className="btn btn-outline-primary btn-sm rounded-3 px-4 w-100">
                                            <i className="fas fa-edit me-1"></i> Editar Registro
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            />
        </div>
    );
}

export default AdminContemplado;